<template>
  <div class="registerBox">
    <Header ref="headRef" style="position:relative" />
    <canvas id="canvas" style="display: none"></canvas>
    <div class="mainContent">
      <h2>Toda tu información estará almacenada y segura</h2>
      <!-- step -->
      <el-steps :active="stepStatue">
        <el-step v-for="item in 4" :key="item"></el-step>
      </el-steps>
      <!-- infoList -->
      <el-collapse accordion class="infoBox" v-model="activeName">
        <!-- ----------------- info 1 ----------------- -->
        <el-collapse-item :name="1" v-loading="loading1">
          <template slot="title">
            <p>
              Información simple y básica
            </p>
            <img src="../../assets/webImg/downIcon.png" alt="" />
          </template>
          <!-- info1 content -->
          <div>
            <!-- ---------- choose position ---------- -->
            <el-cascader
              v-model="positionData"
              :options="positionList"
              clearable
              :props="{
                label: 'text',
                value: 'text',
              }"
              placeholder="Departamento / Provincia / Distrito"
              @change="handleChange"
            ></el-cascader>
            <!-- second row -->
            <div class="formBox">
              <!-- Education List -->
              <el-select
                v-model="dataInfoList.education"
                placeholder="Información Académica"
                clearable
              >
                <el-option
                  v-for="item in getEduList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <!-- wageGradeList -->
              <el-select
                v-model="dataInfoList.monthly_income"
                placeholder="Nivel de ingresos"
                clearable
              >
                <el-option
                  v-for="item in wageGradeList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <!-- email -->
              <div class="emailSelet" id="selectEmailIpt">
                <!-- @blur="closeSelect" -->
                <el-input
                  @input="changeEmail"
                  v-model="dataInfoList.email"
                  placeholder="Correo electrónico"
                  class="selectTitle"
                />
                <transition name="el-zoom-in-top" class="selectTitle">
                  <div
                    v-show="showEmailList"
                    class="selectBox selectTitle"
                    id="selectEmailBox"
                  >
                    <ul class="selectTitle">
                      <li
                        class="selectTitle"
                        v-for="(item, index) in emailShowList"
                        :key="index"
                        @click="chooseEmail(item)"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>

            <!-- submit Info 1 Button -->
            <div class="btnBox" @click="submitBtn(1)">Entregar</div>
          </div>
        </el-collapse-item>
        <!-- ----------------- info 2 ----------------- -->
        <el-collapse-item
          :name="2"
          v-loading="loading2"
          :disabled="stepStatue >= 2 ? false : true"
          id="disBtn2"
        >
          <template slot="title">
            <p>
              Información del contacto
            </p>
            <img src="../../assets/webImg/downIcon.png" alt="" />
          </template>
          <div v-for="item in 2" class="concatBox">
            <h3 style="margin-bottom: 0.2rem">{{ "Contacto" + item }}</h3>
            <!-- FormBox -->
            <div class="formBox" style="margin-top: 0">
              <el-select
                v-model="dataContactInfo['relationship' + item]"
                placeholder="Información Académica"
                clearable
                @change="chooseRlationship"
              >
                <el-option
                  v-for="row in item == 1
                    ? getContactTypeList
                    : getContactTypeList2"
                  :key="row.value"
                  :label="row.text"
                  :value="row.value"
                  :disabled="row.disabled"
                >
                </el-option>
              </el-select>
              <!-- contact phone -->
              <el-input
                maxlength="9"
                v-model="dataContactInfo['contact' + item]"
                placeholder="Número telefónico"
                onkeyup="this.value=this.value.replace(/\D/g,'')"
                onafterpaste="this.value=this.value.replace(/\D/g,'')"
              ></el-input>
              <!-- contact name -->
              <el-input
                v-model="dataContactInfo['contact' + item + '_name']"
                placeholder="Nombre"
              ></el-input>
            </div>
          </div>
          <!-- submit Info 2 Button -->
          <div class="btnBox" @click="submitBtn(2)">Entregar</div>
        </el-collapse-item>
        <!-- ----------------- info 3 ----------------- -->
        <el-collapse-item
          :name="3"
          :disabled="stepStatue >= 3 ? false : true"
          id="disBtn3"
          v-loading="loading3"
        >
          <template slot="title">
            <p>
              Información de identidad
            </p>
            <img src="../../assets/webImg/downIcon.png" alt="" />
          </template>
          <div>
            <!-- upload Box -->
            <el-upload
              action="#"
              :file-list="fileList"
              list-type="picture-card"
              class="uploadBox"
              :auto-upload="false"
              :class="[fileList.length ? 'hideImg' : '']"
              :on-change="changeUpload"
            >
              <img
                style="width:100%"
                src="../../assets/webImg/uploadImg.png"
                alt=""
              />
              <div slot="file" slot-scope="{ file }">
                <el-image
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                  ref="dniImgRef"
                  :preview-src-list="[file.url]"
                ></el-image>
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="catchImg(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="deleteImg(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <!-- ------ first FormBox ------ -->
            <div class="formBox">
              <!-- dni -->
              <el-input
                maxlength="8"
                v-model="dataIdCardInfo.dni"
                placeholder="Ingresa el número de DNI de 8 dígitos"
                oninput="this.value=this.value.replace(/\D/g,'')"
                onafterpaste="this.value=this.value.replace(/\D/g,'')"
              ></el-input>
              <!-- surname1 -->
              <el-input
                v-model="dataIdCardInfo.surname1"
                placeholder="Primer Apellido"
              ></el-input>
              <!-- surname2 -->
              <el-input
                v-model="dataIdCardInfo.surname2"
                placeholder="Segundo Apellido"
              ></el-input>
            </div>

            <!-- second FormBox -->
            <div class="formBox">
              <!-- name1 -->
              <el-input
                v-model="dataIdCardInfo.name1"
                placeholder="Pre Nombre"
              ></el-input>

              <div class="radioBox">
                <el-radio-group v-model="dataIdCardInfo.gender">
                  <el-radio label="W">Femenino</el-radio>
                  <el-radio label="M">Masculino</el-radio>
                </el-radio-group>
              </div>

              <el-date-picker
                v-model="dataIdCardInfo.birthday"
                align="right"
                type="date"
                placeholder="Fecha de nacimiento"
                :picker-options="pickerOptions"
                @change="changeIpt"
                format="dd/MM/yyyy"
                value-format="timestamp"
                :default-value="new Date(1990, 1, 1)"
                :locale="locale"
              >
              </el-date-picker>
            </div>
            <!-- submit Info 3 Button -->
            <div class="btnBox" @click="submitBtn(3)">Entregar</div>
          </div>
        </el-collapse-item>
        <!-- ----------------- info 4 ----------------- -->
        <el-collapse-item
          :name="4"
          :disabled="stepStatue >= 4 ? false : true"
          id="disBtn4"
          v-loading="loading4"
        >
          <template slot="title">
            <p>
              Información de la cuenta bancaria
            </p>
            <img src="../../assets/webImg/downIcon.png" alt="" />
          </template>
          <div>
            <!-- choose Bank -->
            <el-select
              class="bannkStyle"
              v-model="nowBankInfo"
              value-key="bankId"
              placeholder="Nombre de banco"
              clearable
              @change="changeBank"
            >
              <el-option
                v-for="item in bankList"
                :key="item.bankName"
                :label="item.bankName"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="formBox" style="justify-content:flex-start">
            <!-- Choose type -->
            <div class="radioBox smallText">
              <el-radio-group
                @change="changeBnakType"
                v-model="dataBankInfo.bank_card_type"
              >
                <el-radio :label="1">Cuenta corriente</el-radio>
                <el-radio :label="2">Cuenta de ahorro</el-radio>
              </el-radio-group>
            </div>
            <!-- bank_no -->
            <el-input
              maxlength="20"
              v-model="dataBankInfo.bank_no"
              style="margin: 0 0.2rem;"
              :placeholder="
                placehold
                  ? 'Cuenta bancaria（' + placehold + 'dígitos）'
                  : 'Cuenta bancaria'
              "
              oninput="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
            ></el-input>

            <!-- CCI -->
            <el-input
              v-model="dataBankInfo.ifsc_code"
              v-show="
                nowBankInfo.bankId &&
                  nowBankInfo.bankId !== '0001' &&
                  nowBankInfo.bankId !== '0002' &&
                  nowBankInfo.bankId !== '0003' &&
                  nowBankInfo.bankId !== '0004'
              "
              maxlength="20"
              placeholder="CCI (opcional-20 dígitos)"
              oninput="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
            ></el-input>
          </div>

          <!-- submit Info 4 Button -->
          <div class="btnBox" @click="submitBtn(4)">Entregar</div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <ContactOrAbout />
  </div>
</template>

<script>
import Header from "../../components/webComponents/header.vue";
import ContactOrAbout from "../../components/webComponents/contactOrAbout.vue";
import {
  positionList,
  wageGradeList,
  getEduList,
  getContactTypeList,
  getContactTypeList2,
} from "../../components/positionList";

import {
  getBankInfo,
  getUserInforList,
  editStep1Info,
  editStep2Info,
  editStep3Info,
  editStep4Info,
  OCRgetCardInfo,
  getCurrentInfo,
} from "../../utils/api/h5page";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
  },
  props: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() >
            new Date().getTime() - 18 * 365 * 24 * 60 * 60 * 1000
          );
        },
      },
      locale: {
        lang: {
          year: "Year",
          month1: "January",
          month2: "February",
          month3: "March",
          month4: "April",
          month5: "May",
          month6: "June",
          month7: "July",
          month8: "August",
          month9: "September",
          month10: "October",
          month11: "November",
          month12: "December",
          // ... 其他需要翻译的文本
        },
        // 其他配置...
      },
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      stepStatue: null,
      activeName: null,
      positionData: [], // 位置数组
      fileList: [],
      positionList,
      getEduList,
      wageGradeList,
      getContactTypeList,
      getContactTypeList2,
      // 提交个人信息
      dataInfoList: {
        job_type: 0,
        marital_status: 0,
        children_number: 0,
        resident_address: "",
        postal_code: "",
        salary_type: 0,
        salary_day: "",
        salary_day2: "",
        tfn: "",
        // 存在参数
        monthly_income: "",
        education: "",
        resident_state: "",
        resident_city: "",
        resident_district: "",
        email: "",
      },
      // 提交联系人信息
      dataContactInfo: {
        contact1: "",
        contact1_name: "",
        relationship1: "",
        contact2: "",
        contact2_name: "",
        relationship2: "",
      },
      // 提交身份信息
      dataIdCardInfo: {
        card_type: "1",
        dni: "",
        name1: "",
        surname1: "",
        surname2: "",
        gender: "M",
        birthday: "",
        pic_zheng_type: "0",
        pic_fan_type: "-1",
      },
      // 提交银行信息
      dataBankInfo: {
        bank_card_type: 2,
        bank_name: "",
        bank_no: "",
        ifsc_code: "",
      },
      nowBankInfo: {
        bankId: "",
      },
      showEmailList: false,
      emailList: ["@hotmail.com", "@yahoo.com", "@outlook.com", "@gmail.com"],
      emailShowList: [],
      base64url: "",
      bankList: [],
      placehold: "13",
    };
  },
  computed: {},
  watch: {
    stepStatue: function() {
      this.activeName = this.stepStatue;
    },
    showEmailList: function() {
      let ipt = document.getElementById("selectEmailIpt");
      let selectBox = document.getElementById("selectEmailBox");
      selectBox.style.left = ipt.offsetLeft + "px";
      selectBox.style.top =
        ipt.offsetTop + ipt.children[0].clientHeight + 10 + "px";
    },
  },
  created() {},
  mounted() {
    this.getBankList();
    this.getUserInfo();
    this.getCurrentNum();
    this.setDisabledClick();

    window.addEventListener("click", (e) => {
      if (
        e.target.className !== "selectTitle" &&
        e.target.className !== "el-input__inner"
      ) {
        this.showEmailList = false;
      }
      if (
        e.target.className == "el-input__inner" &&
        !e.target.parentNode.className.includes("selectTitle")
      ) {
        this.showEmailList = false;
      }
    });

    window.addEventListener("resize", () => {
      let ipt = document.getElementById("selectEmailIpt");
      let selectBox = document.getElementById("selectEmailBox");
      selectBox.style.left = ipt.offsetLeft + "px";
      selectBox.style.top =
        ipt.offsetTop + ipt.children[0].clientHeight + 10 + "px";
    });
  },
  methods: {
    handleChange(val) {
      if (val.length) {
        this.dataInfoList.resident_state = val[0];
        this.dataInfoList.resident_city = val[1];
        this.dataInfoList.resident_district = val[2];
      } else {
        this.dataInfoList.resident_state = "";
        this.dataInfoList.resident_city = "";
        this.dataInfoList.resident_district = "";
      }
    },

    // 获取用户信息
    getUserInfo(row) {
      getUserInforList().then(({ data }) => {
        // info 1 数据回显
        if (data.data.personal_info.resident_state) {
          this.dataInfoList = data.data.personal_info;

          this.positionData = [
            this.dataInfoList.resident_state,
            this.dataInfoList.resident_city,
            this.dataInfoList.resident_district,
          ];
        }
        // info 2 数据回显
        if (data.data.contact_info.contact1) {
          this.dataContactInfo = data.data.contact_info;
          setTimeout(() => {
            this.setDisabledState();
          }, 10);
        }
        // info 3 数据回显
        if (data.data.identity_info.dni) {
          this.dataIdCardInfo = {
            ...data.data.identity_info,
            birthday: data.data.identity_info.birthday * 1000,
            gender: data.data.identity_info.gender == 0 ? "W" : "M",
          };
          this.fileList = [{ url: data.data.identity_info.id_photo }];
        }

        // info 4 数据回显
        if (data.data.card_info.bank_no) {
          this.dataBankInfo = { ...data.data.card_info };
          this.bankList.map((item) => {
            if (item.bankName == this.dataBankInfo.bank_name) {
              this.nowBankInfo = item;
              if (this.dataBankInfo.bank_card_type == 1) {
                this.placehold = item.cuentaCorriente;
              } else if (this.dataBankInfo.bank_card_type == 2) {
                this.placehold = item.cuentaDeAhorro;
              }
            }
          });
        }

        if (
          row &&
          JSON.parse(localStorage.getItem("userInfo")).is_reloan == 0 &&
          data.data.current_step == 1006
        ) {
          this.$router.push("/faceIdentifyWeb");
        }
      });
    },

    // 禁止点击提示
    setDisabledClick() {
      const disabledBtn2 = document.querySelector("#disBtn2");
      const disabledBtn3 = document.querySelector("#disBtn3");
      const disabledBtn4 = document.querySelector("#disBtn4");
      disabledBtn2.addEventListener("click", () => {
        if (this.stepStatue < 2) {
          return this.$message.error(
            "Primero complete la información en el paso anterior."
          );
        }
      });
      disabledBtn3.addEventListener("click", () => {
        if (this.stepStatue < 3) {
          return this.$message.error(
            "Primero complete la información en el paso anterior."
          );
        }
      });
      disabledBtn4.addEventListener("click", () => {
        if (this.stepStatue < 4) {
          return this.$message.error(
            "Primero complete la información en el paso anterior."
          );
        }
      });
    },

    // 邮箱匹配 补全
    changeEmail(val) {
      if (
        val.includes("@") &&
        !val.includes(".com") &&
        !val.includes(".co") &&
        !val.includes(".c")
      ) {
        this.emailShowList = this.emailList
          .map((item) => {
            if (val.includes("@") && item.slice(item.indexOf("@") + 1)) {
              if (
                item
                  .slice(item.indexOf("@") + 1, -4)
                  .includes(val.slice(val.indexOf("@") + 1))
              ) {
                return (item =
                  val.slice(0, val.indexOf("@") + 1) +
                  item.slice(item.indexOf("@") + 1));
              } else {
                return "";
              }
            }
          })
          .filter(Boolean);
      } else if (
        val.includes(".com") ||
        val.includes(".co") ||
        val.includes(".c")
      ) {
        this.emailShowList = [];
      } else {
        this.emailShowList = this.emailList.map((item) => {
          return (item = val + item);
        });
      }
      // 数组判空
      let arrState = this.emailShowList.every((item) => item == "");
      if (this.emailShowList.length && !arrState) {
        this.showEmailList = true;
      } else {
        this.showEmailList = false;
      }

      if (!this.dataInfoList.email) {
        this.showEmailList = false;
      }
    },

    // 关闭邮箱选择
    closeSelect() {
      this.showEmailList = false;
    },
    // 邮箱选择赋值
    chooseEmail(val) {
      this.dataInfoList.email = val;
      this.showEmailList = false;
    },

    // 处理step和展开内容
    setStepStatue() {
      switch (this.currentStep) {
        case 1001:
          this.stepStatue = 1;
          this.activeName = 1;
          break;
        case 1004:
          this.stepStatue = 1;
          this.activeName = 1;
          break;
        case 1002:
          this.stepStatue = 2;
          this.activeName = 2;
          break;
        case 1005:
          this.stepStatue = 3;
          this.activeName = 3;
          break;
        case 1010:
          this.stepStatue = 4;
          this.activeName = 4;
          break;
        case 1006:
          this.stepStatue = 4;
          this.activeName = 4;
          break;
        case 1110:
          this.stepStatue = 4;
          this.activeName = 4;
          break;
        case 105:
          this.stepStatue = 4;
          this.activeName = 4;
          break;
      }
    },

    getCurrentNum(jump) {
      getCurrentInfo().then(({ data }) => {
        this.currentStep = data.data.current_step;
        this.setStepStatue();
        if (jump) {
          if (data.data.current_step == 1110 || data.data.current_step == 105) {
            this.$router.push("/homeWeb");
          } else if (data.data.current_step == 1006) {
            this.$router.push("/faceIdentifyWeb");
          }
        }
      });
    },

    // 单个提交信息
    submitBtn(row) {
      const {
        resident_state,
        resident_city,
        resident_district,
        monthly_income,
        education,
        email,
      } = this.dataInfoList;
      const {
        contact1,
        contact1_name,
        relationship1,
        contact2,
        contact2_name,
        relationship2,
      } = this.dataContactInfo;
      const {
        dni,
        name1,
        surname1,
        surname2,
        gender,
        birthday,
      } = this.dataIdCardInfo;
      const {
        bank_card_type,
        bank_name,
        bank_no,
        ifsc_code,
      } = this.dataBankInfo;
      switch (row) {
        case 1:
          if (!resident_state || !resident_city || !resident_district) {
            return this.$Toast("Por favor, elija su región");
          }
          if (!monthly_income) {
            return this.$Toast("Elegir ingreso mensual");
          }
          if (!education) {
            return this.$Toast("Por favor, elija un título académico");
          }
          if (!email) {
            return this.$Toast("Por favor, rellene el buzón.");
          }
          if (!this.$validateEmail(email)) {
            return this.$Toast("El formato del correo es incorrecto");
          }
          this.loading1 = true;
          editStep1Info(this.dataInfoList).then(({ data }) => {
            if (data.code == 0) {
              this.getCurrentNum(1);
              this.getUserInfo();
              this.$Toast("Modificación exitosa");
            }
            this.loading1 = false;
          });
          break;
        case 2:
          if (!contact1 || !contact1_name || !relationship1) {
            return this.$Toast(
              "Por favor, complete la información del contacto 1."
            );
          }
          if (!contact2 || !contact2_name || !relationship2) {
            return this.$Toast(
              "Por favor, complete la información del contacto 2."
            );
          }
          this.loading2 = true;
          editStep2Info(this.dataContactInfo).then(({ data }) => {
            if (data.code == 0) {
              this.getCurrentNum(1);
              this.getUserInfo();
              this.$Toast("Modificación exitosa");
            }
            this.loading2 = false;
          });
          break;
        case 3:
          if (!this.fileList.length) {
            return this.$Toast("Por favor, suba su tarjeta de identificación");
          }
          if (!dni || dni.length !== 8) {
            return this.$Toast(
              "Por favor, rellene el número DNI en el formato correcto."
            );
          }
          if (!name1) {
            return this.$Toast("Por favor, introduzca su nombre.");
          }
          if (!surname1 || !surname2) {
            return this.$Toast("Por favor, rellene el apellido.");
          }
          if (!gender) {
            return this.$Toast("Por favor, elija el sexo");
          }
          if (!birthday) {
            return this.$Toast("Por favor, elija la fecha de nacimiento");
          }
          this.loading3 = true;
          editStep3Info({
            ...this.dataIdCardInfo,
            birthday: birthday / 1000,
            gender: gender == "M" ? 1 : 0,
          }).then(({ data }) => {
            if (data.code == 0) {
              this.getCurrentNum(1);
              this.getUserInfo();
              this.$Toast("Modificación exitosa");
            }
            this.loading3 = false;
          });
          break;
        case 4:
          if (!bank_name) {
            return this.$Toast("Por favor, elija el Banco");
          }
          if (!bank_card_type) {
            return this.$Toast("Por favor, elija el tipo de tarjeta bancaria");
          }
          if (!bank_no) {
            return this.$Toast(
              "Por favor, introduzca el número de tarjeta bancaria"
            );
          }
          if (
            ifsc_code.length !== 20 &&
            this.nowBankInfo.bankId !== "0001" &&
            this.nowBankInfo.bankId !== "0002" &&
            this.nowBankInfo.bankId !== "0003" &&
            this.nowBankInfo.bankId !== "0004"
          ) {
            return this.$Toast("CCI (opcional-20 dígitos)");
          }
          if (
            this.nowBankInfo.bankId == "0001" ||
            this.nowBankInfo.bankId == "0002" ||
            this.nowBankInfo.bankId == "0003" ||
            this.nowBankInfo.bankId == "0004"
          ) {
            this.dataBankInfo.ifsc_code = "";
          }
          this.loading4 = true;
          editStep4Info(this.dataBankInfo).then(({ data }) => {
            if (data.code == 0) {
              this.$Toast("Modificación exitosa");
              this.getCurrentNum(1);
              this.getUserInfo(1);
            }
            this.loading4 = false;
          });
          break;
      }
    },
    // delet img
    deleteImg() {
      this.fileList = [];
    },
    // catch img
    catchImg() {
      this.$refs.dniImgRef.showViewer = true;
    },
    // img upload
    changeUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // e.target.result就是文件的Base64地址
        // 在这里你可以做其他的处理，比如将Base64地址赋值给变量
        this.base64url = e.target.result;
        this.fileList = [{ url: file.url }];
        this.uploadRequest(file);
      };

      // 以Base64的形式读取文件
      reader.readAsDataURL(file.raw);
    },
    changeIpt(val) {
      console.log(val);
    },
    // OCR身份识别
    uploadRequest(file) {
      this.$compressImg(this.base64url, file.raw).then((data) => {
        file.raw = data;
        const formData = new FormData();
        formData.append("card_type", 1);
        formData.append("fs1_size", file.raw.size);
        formData.append("fs1", file.raw);
        formData.append("access_token", localStorage.getItem("token"));
        this.loading3 = true;
        OCRgetCardInfo(formData).then(({ data }) => {
          if (data.code == 0) {
            const {
              idNumber,
              name,
              fatherName,
              motherName,
              gender,
              birthday,
              resourceId,
            } = data.data;
            if (idNumber) {
              this.dataIdCardInfo.dni = idNumber;
            }
            if (name) {
              this.dataIdCardInfo.name1 = name;
            }
            if (fatherName) {
              this.dataIdCardInfo.surname1 = fatherName;
            }
            if (motherName) {
              this.dataIdCardInfo.surname2 = motherName;
            }
            if (gender) {
              this.dataIdCardInfo.gender = gender == "M" ? "M" : "W";
            }

            if (birthday) {
              this.dataIdCardInfo.birthday = this.$setTimeStr(birthday);
            }
            console.log(data.data, resourceId.toString());
            this.dataIdCardInfo.id_photo_id = resourceId.toString();
            this.dataIdCardInfo.ocr_json = data.data;
          } else {
            this.fileList = [];
          }
          this.loading3 = false;
        });
      });
    },

    // get Bank
    getBankList() {
      getBankInfo({ access_token: "281d367dfc572f0ebe3f718b103eb795" }).then(
        ({ data }) => {
          this.bankList = data.data.bankList;
        }
      );
    },

    // choose Bank
    changeBank(val) {
      this.dataBankInfo.bank_name = val.bankName;
      this.changeBnakType();
    },

    // 更改银行类型
    changeBnakType() {
      if (this.dataBankInfo.bank_card_type == 1) {
        this.placehold = this.nowBankInfo.cuentaCorriente;
      } else if (this.dataBankInfo.bank_card_type == 2) {
        this.placehold = this.nowBankInfo.cuentaDeAhorro;
      }
    },

    chooseRlationship() {
      this.setDisabledState();
    },

    setDisabledState() {
      const { relationship1, relationship2 } = this.dataContactInfo;
      if (relationship1 == 1) {
        getContactTypeList2[0].disabled = true;
      } else if (relationship1 !== 1) {
        getContactTypeList2[0].disabled = false;
      }

      if (relationship2 == 1) {
        getContactTypeList[0].disabled = true;
      } else if (relationship2 !== 1) {
        getContactTypeList[0].disabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.registerBox {
  background-color: #f5f5f5;
}
.mainContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.32rem;
    color: #333333;
    line-height: 0.45rem;
    margin: 0.46rem 0 0.58rem;
  }
  .el-steps {
    width: 9rem;
    margin-bottom: 0.7rem;
  }
  /deep/ .el-step__icon {
    display: flex;
    width: 0.54rem;
    height: 0.54rem;
    background-color: #d3d5df;
    color: #fff;
    border: none;
    font-size: 0.23rem;
  }
  /deep/ .el-step.is-horizontal .el-step__line {
    width: 1.9rem;
    height: 0;
    border: 0.01rem dashed #d3d5df;
    background: transparent;
    top: 50%;
    left: 0.7rem;
    transform: translateY(-50%);
  }
  /deep/ .is-finish {
    .el-step__icon {
      background-color: #c90000;
    }
    .el-step__line {
      border: 0.01rem dashed #c90000 !important;
    }
    .el-step__line-inner {
      display: none;
    }
  }

  .infoBox {
    width: 12.22rem;
    /deep/ .el-collapse-item__arrow {
      display: none;
    }

    /deep/ .el-collapse-item__header {
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.28rem;
      color: #333333;
      padding: 0.38rem 0.32rem;
      img {
        transform: rotate(180deg);
        transition: all 0.3s;
        margin-left: 0.08rem;
        width: 0.3rem;
        margin-top: 0.05rem;
      }
    }
    /deep/ .el-collapse-item__wrap {
      border-bottom-left-radius: 0.2rem;
      border-bottom-right-radius: 0.2rem;
      padding: 0 0.38rem;
    }
    /deep/ .el-collapse-item {
      background: #ffffff;
      border: 0.01rem solid #ececec;
      border-radius: 0.2rem;
      margin-bottom: 0.2rem;
      overflow: hidden;
    }
    /deep/ .el-collapse-item__content {
      padding-bottom: 0.37rem;
    }
    /deep/ .is-disabled {
      img {
        opacity: 0.3;
      }
    }
    /deep/ .is-active {
      img {
        transform: rotate(0);
      }
    }
    /deep/ .el-input {
      width: 3.7rem;
    }
    /deep/ .el-cascader {
      width: 100%;
      border-radius: 0.1rem;
    }
    /deep/ .el-cascader .el-input__inner,
    /deep/ .el-cascader .el-input {
      width: 100%;
    }

    /deep/ .el-input__inner {
      width: 3.7rem;
      height: 0.6rem;
      border: 0.02rem solid #ececec;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.2rem;
      border-radius: 0.1rem;
    }
    /deep/ .el-input__icon {
      font-size: 0.2rem;
      line-height: 0.6rem;
    }
    .formBox {
      display: flex;
      justify-content: space-between;
      margin-top: 0.24rem;
    }
    .emailSelet {
      // position: relative;
      .selectBox {
        position: absolute;
        width: 3.7rem;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        overflow: auto;
        li {
          cursor: pointer;
          padding: 0.15rem;
          font-size: 0.2rem;
          &:hover {
            background-color: #f5f6f7;
          }
        }
      }
    }

    .btnBox {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4rem;
      height: 0.8rem;
      background: #c90000;
      border-radius: 0.4rem;
      margin: 0.36rem auto 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.24rem;
      color: #ffffff;
    }

    .concatBox {
      overflow: hidden;
      margin-bottom: 0.2rem;
      h3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.22rem;
        color: #333333;
      }
    }

    /deep/ .uploadBox {
      margin-bottom: 0.73rem;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-upload {
      width: 5.9rem;
      height: 3.1rem;
      border: none;
    }
    .hideImg {
      /deep/ .el-upload {
        display: none;
      }
    }
    /deep/ .el-upload-list__item {
      margin: 0;
      width: 5.9rem;
      height: 3.1rem;
      transition: none;
      div {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
      }
    }

    .radioBox {
      width: 3.7rem;
      height: 0.6rem;
      border-radius: 0.1rem;
      border: 0.02rem solid #ececec;
      display: flex;
      align-items: center;
      padding: 0 0.38rem;
      /deep/ .el-radio {
        display: flex;
        align-items: center;
        margin-right: 0;
      }
      /deep/ .el-radio-group {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      /deep/ .el-radio__label {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.18rem;
        color: #666666;
      }
      /deep/ .el-radio__inner {
        width: 0.2rem;
        height: 0.2rem;
      }
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        width: 0.2rem;
        height: 0.2rem;
        border: 0.03rem solid #c90000;
        background: #fff;
      }
      /deep/ .el-radio__inner::after {
        background-color: #c90000;
        width: 0.11rem;
        height: 0.11rem;
      }
    }
    .smallText {
      padding: 0 0.17rem;
      /deep/ .el-radio__label {
        font-size: 0.15rem;
      }
    }
    /deep/ .el-input__prefix {
      padding-left: 0.05rem;
    }
    /deep/ .el-date-editor {
      .el-input__inner {
        padding-left: 0.4rem;
      }
    }
    .bannkStyle {
      width: 100%;
      /deep/ .el-input,
      /deep/.el-input__inner {
        width: 100%;
      }
    }
  }
}
</style>

<style>
.el-collapse,
.el-collapse-item__header {
  border-bottom: none !important;
  border-top: none !important;
}
</style>
